export const formatToLocalizedNumber = (
  number: number
): string => {
  const localeBcp47 = "en-GB"
  return new Intl.NumberFormat(localeBcp47, {
    minimumFractionDigits: 2,
  }).format(number)
}
